import React, { Component } from "react";
import { withRouter } from "react-router";
import { Col, Divider } from "antd";
import {
  UserContributionDetails,
  UserDateDetails,
  DetailsData,
  IconContainer,
  DetailsContainer,
  RowProfileInformationHeading,
  AddressDetails,
  ProfileAddressContainer,
  UserEmail,
  UserNameBlock,
  AddressWrapper
} from "../../../styles";
import moment from "moment"
import Profile from "../../../../../CommonComponents/svgs/Profile";
import { DataValue, DisplayFlex, EllipsisUnderline, EllipsisDataValueWrapper,
  EllipsisPointer, EllipsisContent } from "../../../../../CommonComponents/commonStyles";

class ExpandedRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countries: []
    }
  }

  componentDidMount() {    
    const { countries } = this.props;
    if(countries) this.setState({
      countries: countries
    });
  }

  getCountry(country_id) {
    if(this.state.countries.length > 0 && country_id) {
      let country = this.state.countries.find(item => item.value == country_id);
      if(country) return country.desc;
    }
    return;
  }
  recordLegacyValue(record,legacy){
  let percentageValue=0
    if(record && record.legacy){
      if(record.legacy.bestow && legacy==="bestow"){
        percentageValue= record.legacy.bestow
      }
      else if(record.legacy.endow && legacy==="endow"){
        percentageValue= record.legacy.endow
      }
      else if(record.legacy.others && legacy==="others"){
        percentageValue= record.legacy.others
      }
    }
    return percentageValue
  }

  render() {

    const { record } = this.props;

    let isPrimaryAdvisorExist = record.accountAdvisors && record.accountAdvisors.findIndex(p => p.primary == true);

    let isSecondaryAdvisorExist = record.accountAdvisors && record.accountAdvisors.findIndex(p => p.primary == false);

    return (
      <div className="expandContainer">
       <Col lg={8} sm={24} xs={24}>
            <DetailsContainer>
              <IconContainer>
                <Profile />
              </IconContainer>
              <DetailsData>
                <RowProfileInformationHeading>
                  Primary Advisor
                </RowProfileInformationHeading>

                {
                  isPrimaryAdvisorExist == -1
                  && <UserContributionDetails>No records found.</UserContributionDetails>
                }

                {this.props.record.accountAdvisors.map(obj => {
                 
                if(obj.primary==true){

                  let addr = obj.address.addressLine1 ? obj.address.addressLine1: '';

                  if(addr) addr = obj.address.addressLine2 ? `${addr}, ${obj.address.addressLine2}`: addr;

                  else addr = obj.address.addressLine2 ? obj.address.addressLine2: '';

                  if(addr) addr = obj.address.addressLine3 ? `${addr}, ${obj.address.addressLine3}`: addr;

                  else addr = obj.address.addressLine3 ? obj.address.addressLine3: '';

                  return (
                    <div>
                      <UserContributionDetails>
                        <UserNameBlock className="breakContent">
                          {obj.name}
                        </UserNameBlock>
                      </UserContributionDetails>
                      <UserContributionDetails>
                        DOB:
                        <UserDateDetails>
                          {
                            obj.dateOfBirthStr ? obj.dateOfBirthStr : <DataValue> &mdash; </DataValue>
                          }
                        </UserDateDetails>
                      </UserContributionDetails>
                      <UserContributionDetails>
                        Email:{" "}
                        <UserEmail className="breakContent">
                        <EllipsisDataValueWrapper>
                            <EllipsisUnderline>{obj.email}</EllipsisUnderline>
                            <EllipsisContent>
                              {obj.email}
                            </EllipsisContent>
                          </EllipsisDataValueWrapper>
                        </UserEmail>
                      </UserContributionDetails>
                      <UserContributionDetails>
                        Phone:{" "}
                        <UserDateDetails className="breakContent">
                          {obj.phone}
                        </UserDateDetails>
                      </UserContributionDetails>
                      <UserContributionDetails>
                        <DisplayFlex>
                          <div>Address:</div>
                          <AddressWrapper>
                            {addr && (
                              <UserDateDetails className="breakWord">
                                {addr},{" "}
                              </UserDateDetails>
                            )}
                            {obj.address.city && (
                              <UserDateDetails className="breakWord">
                                {obj.address.city},
                              </UserDateDetails>
                            )}
                            {obj.address.state && obj.address.zipCode && (
                              <AddressDetails>
                                {obj.address.state}, {obj.address.zipCode},
                              </AddressDetails>
                            )}
                            {obj.address.state && !obj.address.zipCode && (
                              <AddressDetails>
                                {obj.address.state},
                              </AddressDetails>
                            )}
                            {!obj.address.state && obj.address.zipCode && (
                              <AddressDetails>
                                {obj.address.zipCode},
                              </AddressDetails>
                            )}
                            {obj.address.country && (
                              <AddressDetails>
                                {this.getCountry(obj.address.country)}
                              </AddressDetails>
                            )}
                          </AddressWrapper>
                        </DisplayFlex>
                      </UserContributionDetails>
                    </div>
                  );
                  }

                })}
                
              </DetailsData>
            </DetailsContainer>
            <DetailsContainer>
              <IconContainer>
                <Profile />
              </IconContainer>
              <DetailsData>
                <RowProfileInformationHeading>
                  Secondary Advisor
                </RowProfileInformationHeading>

                {
                  isSecondaryAdvisorExist == -1
                  && <UserContributionDetails>No records found.</UserContributionDetails>
                }

                {this.props.record.accountAdvisors.map(obj => {

                if(obj.primary == false){


                  let addr = obj.address.addressLine1 ? obj.address.addressLine1: '';

                  if(addr) addr = obj.address.addressLine2 ? `${addr}, ${obj.address.addressLine2}`: addr;

                  else addr = obj.address.addressLine2 ? obj.address.addressLine2: '';

                  if(addr) addr = obj.address.addressLine3 ? `${addr}, ${obj.address.addressLine3}`: addr;

                  else addr = obj.address.addressLine3 ? obj.address.addressLine3: '';

                  return (
                    <div>
                      <UserContributionDetails>
                        <UserNameBlock className="breakContent">
                          {obj.name}
                        </UserNameBlock>
                      </UserContributionDetails>
                      <UserContributionDetails>
                        DOB:
                        <UserDateDetails>
                          {
                            obj.dateOfBirthStr ? obj.dateOfBirthStr : <DataValue> &mdash; </DataValue>
                          }
                        </UserDateDetails>
                      </UserContributionDetails>
                      <UserContributionDetails>
                        Email:{" "}
                        <UserEmail className="breakContent">
                        <EllipsisDataValueWrapper>
                            <EllipsisUnderline>{obj.email}</EllipsisUnderline>
                            <EllipsisContent>
                              {obj.email}
                            </EllipsisContent>
                          </EllipsisDataValueWrapper>
                        </UserEmail>
                      </UserContributionDetails>
                      <UserContributionDetails>
                        Phone:{" "}
                        <UserDateDetails className="breakContent">
                          {obj.phone}
                        </UserDateDetails>
                      </UserContributionDetails>
                      <UserContributionDetails>
                        <DisplayFlex>
                          <div>Address:</div>
                          <AddressWrapper>
                            {addr && (
                              <UserDateDetails className="breakWord">
                                {addr},{" "}
                              </UserDateDetails>
                            )}
                            {obj.address.city && (
                              <UserDateDetails className="breakWord">
                                {obj.address.city},
                              </UserDateDetails>
                            )}
                            {obj.address.state && obj.address.zipCode && (
                              <AddressDetails>
                                {obj.address.state}, {obj.address.zipCode},
                              </AddressDetails>
                            )}
                            {obj.address.state && !obj.address.zipCode && (
                              <AddressDetails>
                                {obj.address.state},
                              </AddressDetails>
                            )}
                            {!obj.address.state && obj.address.zipCode && (
                              <AddressDetails>
                                {obj.address.zipCode},
                              </AddressDetails>
                            )}
                            {obj.address.country && (
                              <AddressDetails>
                                {this.getCountry(obj.address.country)}
                              </AddressDetails>
                            )}
                          </AddressWrapper>
                        </DisplayFlex>
                      </UserContributionDetails>
                    </div>
                  );
                }
                })}
              </DetailsData>
            </DetailsContainer>
            <Divider type="vertical" className="mx3" />
          </Col>

          <Col lg={8} sm={24} xs={24}>
            {
              this.props.record.designatedParties && this.props.record.designatedParties.length <= 0
              && <DetailsContainer>
                <IconContainer>
                  <Profile />
                </IconContainer>
                <DetailsData>
                <RowProfileInformationHeading>
                  Interested Party 1
                </RowProfileInformationHeading>            
                <UserContributionDetails>No records found.</UserContributionDetails>
              </DetailsData>
              </DetailsContainer>
            }

            {this.props.record.designatedParties.map((obj, index) => {

              let addr = '';

              if(obj.address.addressLine1) addr = obj.address.addressLine1;
              if(obj.address.addressLine2) addr = `${addr}, ${obj.address.addressLine2}`;
              if(obj.address.addressLine3) addr = `${addr}, ${obj.address.addressLine3}`;

              return (
                <DetailsContainer>
                  <IconContainer>
                    <Profile />
                  </IconContainer>
                  <DetailsData>
                    <RowProfileInformationHeading>
                      Interested Party {index + 1}
                    </RowProfileInformationHeading>

                    <UserContributionDetails>
                      <UserNameBlock className="breakContent">{`${
                        obj.salutation ? obj.salutation : ""
                      } ${obj.name} ${obj.middleName ? obj.middleName : ""} ${
                        obj.lastName
                      },  ${
                        obj.suffix ? obj.suffix : ""
                      }`}</UserNameBlock>
                    </UserContributionDetails>

                    <UserContributionDetails>
                      Email:{" "}
                      <UserEmail className="breakContent">
                      <EllipsisDataValueWrapper>
                            <EllipsisUnderline>{obj.email}</EllipsisUnderline>
                            <EllipsisContent>
                              {obj.email}
                            </EllipsisContent>
                          </EllipsisDataValueWrapper>
                      </UserEmail>
                    </UserContributionDetails>
                    <UserContributionDetails>
                      Phone:
                      <UserDateDetails className="breakContent">
                        {obj.phone}
                      </UserDateDetails>
                    </UserContributionDetails>

                    <UserContributionDetails>
                      <DisplayFlex>
                        <div>Address:</div>
                        <AddressWrapper>
                          {addr && (
                            <UserDateDetails className="breakWord">
                              {addr},{" "}
                            </UserDateDetails>
                          )}
                          {obj.address.city && (
                            <UserDateDetails className="breakWord">
                              {obj.address.city},
                            </UserDateDetails>
                          )}
                          {obj.address.state && obj.address.zipCode && (
                            <AddressDetails>
                              {obj.address.state}, {obj.address.zipCode},
                            </AddressDetails>
                          )}
                          {obj.address.state && !obj.address.zipCode && (
                            <AddressDetails>{obj.address.state},</AddressDetails>
                          )}
                          {!obj.address.state && obj.address.zipCode && (
                            <AddressDetails>
                              {obj.address.zipCode},
                            </AddressDetails>
                          )}
                          {obj.address.country && (
                            <AddressDetails>
                              {this.getCountry(obj.address.country)}
                            </AddressDetails>
                          )}
                        </AddressWrapper>
                      </DisplayFlex>
                    </UserContributionDetails>
                    <UserContributionDetails>
                      Relation:
                      {obj.relation ? (
                        <UserDateDetails className="breakContent">
                          {obj.relation}
                        </UserDateDetails>
                      ) : (
                        <UserDateDetails className="breakContent">
                          &mdash;
                        </UserDateDetails>
                      )}
                    </UserContributionDetails>
                    <UserContributionDetails>
                      Access Levels:
                      <UserDateDetails className="breakContent">
                        {obj.access}
                      </UserDateDetails>
                    </UserContributionDetails>
                  </DetailsData>
                </DetailsContainer>
              );
            })}
          </Col>

          <Col  lg={8} sm={24} xs={24}>
            <DetailsContainer>
              <IconContainer>
                <Profile />
              </IconContainer>
              <DetailsData>
                <RowProfileInformationHeading>
                  Legacy Options
                </RowProfileInformationHeading>

                <UserContributionDetails>
                  Bestow to Others:
                  <UserDateDetails>
                    {`${this.recordLegacyValue(this.props.record,"bestow")}% `}
                  </UserDateDetails>
                </UserContributionDetails>
                <UserContributionDetails>
                  Endow to Charity:
                  <UserDateDetails>
                  {`${this.recordLegacyValue(this.props.record,"endow")}% `}
                  </UserDateDetails>
                </UserContributionDetails>
                <UserContributionDetails>
                  Others:
                  <UserDateDetails>
                  {`${this.recordLegacyValue(this.props.record,"others")}% `}
                  </UserDateDetails>
                </UserContributionDetails>
              </DetailsData>
            </DetailsContainer>
          </Col>
      </div>
    );
  }
}

export default withRouter(ExpandedRow);
